/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetTeamRolesPathParams = NonNullable<operations['getTeamRoles']['parameters']['path']>;

export type GetTeamRolesQueryParams = NonNullable<operations['getTeamRoles']['parameters']['query']>;

export interface Input extends GetTeamRolesPathParams {
  apiVersion?: string;
  query?: GetTeamRolesQueryParams;
}

export async function getTeamRoles(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/teams/{teamKey}/roles', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
